import standardAPI from '@/api/standard_items';

const state = {
  categories: [],
  categories_status: '',
  categories_MetaData: {},
  categories_page: 1,
  categories_perPage: 10,
};

const responseUrl = '/world-tours/categories';

const getters = {};

const actions = {
  set_current_page ({ commit }, page) {
    commit('SET_CURRENT_PAGE', page);
  },
  set_perPage ({ commit }, max) {
    commit('SET_PER_PAGE', max);
  },
  fetch_categories ({ commit }, getOptions) {
    commit('CATEGORIES_REQUEST');
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
      token: getOptions.token,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            commit('CATEGORIES_SUCCESS', response);
            commit('CATEGORIES_READY');
            resolve(response);
          } else if (response.status === 404) {
            commit('CATEGORIES_READY');
            reject(response);
          } else {
            commit('CATEGORIES_ERROR');
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  add_category ({ commit, dispatch }, itemData) {
    commit('CATEGORIES_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.add_item(preparedData, (response) => {
        if (response.status === 'created') {
          resolve(response);
        } else {
          commit('CATEGORIES_READY');
          reject(response);
        }
      });
    });
  },
  edit_category ({ commit, dispatch }, itemData) {
    commit('CATEGORIES_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl + '/',
    };
    return new Promise((resolve, reject) => {
      standardAPI.edit_item(preparedData, (response) => {
        if (response.status === 'updated') {
          resolve(response);
        } else {
          commit('CATEGORIES_READY');
          reject(response);
        }
      });
    });
  },
  remove_category ({ commit, dispatch }, itemData) {
    commit('CATEGORIES_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.remove_items(preparedData, (response) => {
        if (response.status === 'deleted') {
          resolve(response);
        } else {
          commit('CATEGORIES_READY');
          reject(response);
        }
      });
    });
  },
  reorder_category ({ commit, dispatch }, orderData) {
    const preparedData = {
      orderData,
      url: responseUrl + '/reorder',
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item(preparedData, (response) => {
        if (response.status === 'reorder') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
  set_category_order ({ commit, dispatch }, itemData) {
    const preparedData = {
      itemData,
      url: responseUrl + '/set-reorder-index/' + itemData.id,
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item_number(preparedData, (response) => {
        if (response.status === 'reorder') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
};

const mutations = {
  SET_CURRENT_PAGE: (state, pageNumber) => {
    state.categories_page = pageNumber;
  },
  SET_PER_PAGE: (state, max) => {
    state.categories_perPage = max;
  },
  CATEGORIES_READY: (state) => {
    state.categories_status = 'ready';
  },
  CATEGORIES_REQUEST: (state) => {
    state.categories_status = 'loading';
  },
  CATEGORIES_SUCCESS: (state, response) => {
    if (response && response.meta) {
      state.categories_MetaData.meta = response.meta;
      state.categories_MetaData.links = response.links;
    }
    if (response && response.data) {
      state.categories = response.data.map((category) => {
        category.checked = false; // need for some pages where we can select categories
        return category;
      }) || [];
    }
    state.categories_status = 'success';
  },
  CATEGORIES_ERROR: (state) => {
    state.categories_status = 'error';
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
